var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneTimeCodeSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3892 3.375H41.3892L43.0767 5.0625V48.9375L41.3892 50.625H14.3892L12.7017 48.9375V5.0625L14.3892 3.375ZM16.0767 47.25H39.7017V6.75H16.0767V47.25Z",
    fill: "#278DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.814 40.736H20.044L20.114 39.168L18.798 40.008L18.406 39.336L19.792 38.622L18.406 37.908L18.798 37.236L20.114 38.09L20.044 36.522H20.814L20.744 38.09L22.06 37.236L22.452 37.908L21.052 38.622L22.452 39.336L22.06 40.008L20.744 39.168L20.814 40.736ZM25.6675 40.736H24.8975L24.9675 39.168L23.6515 40.008L23.2595 39.336L24.6455 38.622L23.2595 37.908L23.6515 37.236L24.9675 38.09L24.8975 36.522H25.6675L25.5975 38.09L26.9135 37.236L27.3055 37.908L25.9055 38.622L27.3055 39.336L26.9135 40.008L25.5975 39.168L25.6675 40.736ZM30.521 40.736H29.751L29.821 39.168L28.505 40.008L28.113 39.336L29.499 38.622L28.113 37.908L28.505 37.236L29.821 38.09L29.751 36.522H30.521L30.451 38.09L31.767 37.236L32.159 37.908L30.759 38.622L32.159 39.336L31.767 40.008L30.451 39.168L30.521 40.736ZM35.3745 40.736H34.6045L34.6745 39.168L33.3585 40.008L32.9665 39.336L34.3525 38.622L32.9665 37.908L33.3585 37.236L34.6745 38.09L34.6045 36.522H35.3745L35.3045 38.09L36.6205 37.236L37.0125 37.908L35.6125 38.622L37.0125 39.336L36.6205 40.008L35.3045 39.168L35.3745 40.736Z",
    fill: "#278DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTimeCodeSettings);
export default __webpack_public_path__ + "static/media/OneTimeCodeSettings.5ceb10617ed478968f898dfd98ba6990.svg";
export { ForwardRef as ReactComponent };